import React from 'react'
import { useDispatch } from 'react-redux'
import { Emoji } from 'emoji-mart'

import './styles.scss'
import withChannels from 'hocs/withChannels'
import { removeReaction } from 'redux/actions/conversations/messagesAct'

/**
 * React Component for the reactions of a message
 * @param {Object} props.reactions Array of reactions
 * @param {Object} props.messageId Message Id
 * @param {Object} props.userId User Id
 * @param {Object} props.channel Channel
 */
export const Reactions = ({ reactions, messageId, userId }) => {
  const dispatch = useDispatch()

  const onRemoveReaction = () => {
    try {
      dispatch(removeReaction({ userId, messageId }))
    } catch (error) {
      console.error('error: ', error)
    }
  }

  if (reactions?.length > 0) {
    return (
      <div className="message-reaction">
        {
          reactions.map((reaction) => {
            return (
              <div
                key={reaction.emoji}
                onClick={() => reaction.type === 'operator' ? onRemoveReaction() : null}
                className={`message-reaction__emoji ${reaction.type === 'user' ? 'message-reaction__emoji--user' : 'message-reaction__emoji--operator'}`}
              >
                <span>
                  <Emoji
                    emoji={reaction.emoji}
                    set='apple'
                    size={16}
                    fallback={(emoji, props) => {
                      if (props.emoji === '❤') return '❤️'

                      return emoji ? `:${emoji.short_names[0]}:` : props.emoji
                    }}
                  />
                </span>
              </div>
            )
          })
        }
      </div>
    )
  }

  return null
}

export default withChannels(Reactions, ['instagram__instagram', 'whatsapp__whatsapp', 'facebook__facebook'])